<template>
  <div
    class="w-full border-t-2 my-1 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-7 gap-x-4 gap-y-2"
    id="dataCard"
  >
    <!-- Col 1 -->
    <div class="flex flex-col space-y-1 w-max">
      <InfoLabel
        label="COSTO"
        icon="bx-money"
        :tooltip="'Costo de compra del producto'"
        :value="`
          Bs.S ${$functions.prices.getPrecioNeto(content, null, true, true, true)} -
          $ ${$functions.prices.getPrecioNeto(content, content?.prove_cfg?.FactorCambiario, true, true, true)}
        `"
      />
      <InfoLabel
        v-if="content?.costo_cendis !== null && content?.costo_cendis !== undefined"
        label="COSTO CENDIS"
        icon="bx-money"
        :tooltip="'Costo cargado por lista de precios (Cendis)'"
        :value="`
          Bs.S ${parseFloat(content.costo_cendis).toFixed(2)} -
          $ ${(parseFloat(content.costo_cendis) / parseFloat(content?.prove_cfg?.FactorCambiario || 1)).toFixed(2)}
        `"
      />
      <InfoLabel
        v-else
        label="COSTO CENDIS"
        icon="bx-money"
        :tooltip="'Costo cargado por lista de precios (Cendis)'"
        value="N/A"
      />
      <label
        class="flex flex-col ml-1"
        role="button"
        @click="$functions.modals.openMejorPrecioModal(content?.barra, $axios, $apiRoute)"
        v-tooltip="{
          content: content?.dataprod?.mejor_precio_bool
            ? 'Tienes el mejor precio de venta entre todas las droguerías'
            : 'No tienes el mejor precio de venta entre todas las droguerías',
          triggers: ['hover', 'mouseleave'],
          autoHide: true
        }"
      >
        <span class="text-xs font-medium text-slate-700">MPV:</span>
        <p
          v-if="content?.dataprod"
          class="flex font-semibold ml-1 text-xs items-center"
          :class="content?.dataprod?.mejor_precio_bool
            ? 'bg-green-600 text-white w-fit rounded px-1'
            : 'bg-red-600 text-white w-fit rounded px-1'"
        >
          <i :class="content?.dataprod?.mejor_precio_bool ? 'bx bx-check-circle' : 'bx bx-error'"></i>
          <span class="ml-1 text-xs w-max sm:w-auto">
            {{ content.dataprod.mppliqBs?.toFixed(2) }} - {{ content.dataprod.mppliq?.toFixed(2) }}
          </span>
        </p>
        <p
          v-else
          class="flex font-semibold ml-1 text-xs items-center bg-green-600 text-white w-fit rounded px-1"
        >
          <i class="bx bx-check-circle"></i>
          <span class="ml-1 text-xs">
            {{ parseFloat(content?.precio1).toFixed(2) }} -
            {{ (parseFloat(content?.precio1) / parseFloat(content?.prove_cfg?.FactorCambiario)).toFixed(2) }}
          </span>
        </p>
      </label>
    </div>

    <!-- Col 2 -->
    <div class="flex flex-col space-y-1 w-max">
      <InfoLabel
        label="COSTO MOLECULA"
        icon="bx-health"
        :value="
          content.molecula !== 'POR DEFINIR'
            ? `Bs.S ${$functions.prices.getPrecioMolecula(content)[0]} - $ ${$functions.prices.getPrecioMolecula(content)[1]}`
            : 'N/A'
        "
      />
      <label
        class="flex flex-col ml-1"
        role="button"
        @click="$functions.modals.openMoleculasModal(content?.molecula, content?.barra, $axios, $apiRoute)"
        v-tooltip="{ content: 'Mejor precio de compra de la molécula por laboratorio', triggers: ['hover'], autoHide: true }"
      >
        <span class="text-xs font-medium text-slate-700">MPC:</span>
        <p
          v-if="content.molecula !== 'POR DEFINIR'"
          class="flex font-semibold ml-1 text-xs items-center"
          :class="content?.bool_marca ? 'bg-green-600 text-white w-fit rounded px-1' : 'bg-red-600 text-white w-fit rounded px-1'"
        >
          <i :class="content?.bool_marca ? 'bx bx-check-circle mr-1' : 'bx bx-error mr-1'"></i>
          <span class="ml-1 text-xs w-max sm:w-auto">
            Bs.S {{ $functions.prices.getMejorPrecioMolecula(content)[0] }} -
            $ {{ $functions.prices.getMejorPrecioMolecula(content)[1] }}
          </span>
        </p>
        <p v-else class="ml-1 text-xs font-bold">N/A</p>
      </label>
    </div>

    <!-- Col 3 -->
    <div class="flex flex-col space-y-1 w-max">
      <InfoLabel label="CÓDIGO DE BARRA" icon="bx-barcode" :value="content.barra" />
      <InfoLabel label="UNIDAD DEL BULTO" icon="bxs-cube" :value="content.tpmBulto > 0 ? content.tpmBulto : content.bulto" />
    </div>

    <!-- Col 4 -->
    <div class="flex flex-col space-y-1 w-full">
      <InfoLabel label="MARCA" icon="bx-purchase-tag" :value="content.marca" />
      <InfoLabel label="SUBMARCA" icon="bxs-purchase-tag" :value="content.subgrupo" />
    </div>

    <!-- Col 5 -->
    <div class="flex flex-col space-y-1 w-max">
      <InfoLabel label="INVENTARIO" icon="bx-archive-in" :value="content.cantidad" />
      <InfoLabel label="UNIDADES EN TRÁNSITO" icon="bx-car" :value="content.transito ?? 0" />
    </div>

    <!-- Col 6 -->
    <div class="flex flex-col space-y-1 w-max">
      <InfoLabel label="DÍAS EN INVENTARIO" icon="bx-calendar-check" :value="Math.ceil(content.dias)" />
      <label
        class="flex flex-col ml-1"
        v-tooltip="{
          content: `VMD: ${content.vmd_inventario}<br>VMD GRUPO: ${content.vmd ?? 'N/A'}<br>VMD TOTAL: ${(parseFloat(content.vmd_inventario) + parseFloat(content.vmd ?? '0.0000')).toFixed(4)}`,
          html: true
        }"
      >
        <span class="text-xs font-medium text-slate-700">VENTA MEDIA DIARIA:</span>
        <p class="flex font-bold ml-1 text-xs items-center">
          <i class="bx bx-dollar-circle"></i>
          <span class="ml-1 text-xs" v-if="content.vmd !== null">
            {{ content.vmd_inventario }} | {{ content.vmd }}
          </span>
          <span class="ml-1 text-xs" v-else>{{ content.vmd_inventario }}</span>
        </p>
      </label>
    </div>

    <!-- Col 7: sugerido ocupa 2 filas -->
    <div class="flex flex-col space-y-1 xl:row-span-2 xl:col-span-1 col-span-full w-max">
      <label
        class="flex flex-col ml-1"
        v-tooltip="{ content: 'Cantidad sugerida de los productos a pedir', triggers: ['hover'], autoHide: true }"
      >
        <span class="text-xs font-medium text-slate-700">SUGERIDO SEGÚN DÍAS:</span>
        <div class="flex flex-col space-y-0.5">
          <p class="flex font-bold text-xs items-center">15 DÍAS → {{ Math.ceil(content.sug15) }}</p>
          <p class="flex font-bold text-xs items-center">30 DÍAS → {{ Math.ceil(content.sug30) }}</p>
          <p class="flex font-bold text-xs items-center">45 DÍAS → {{ Math.ceil(content.sug45) }}</p>
          <p class="flex font-bold text-xs items-center">60 DÍAS → {{ Math.ceil(content.sug60) }}</p>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import InfoLabel from '../InfoLabel.vue';
export default {
  name: 'ProductoInfo',
  props: [
    'title', 'content', 'cardClass', 'cardSize',
    'headerClass', 'index', 'lastIndex', 'type', 'user'
  ],
  components: {
    InfoLabel
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
    }
  },
  inheritAttrs: false
};
</script>
